var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-form-select', {
    class: _vm.fieldClass,
    attrs: {
      "id": _vm.id,
      "required": _vm.required,
      "name": _vm.name,
      "options": _vm.options
    },
    on: {
      "change": function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      }
    },
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }